import React, { Component } from "react";
import Header from "./header";
import SidePanel from "./sidePanel";
import Dashboard from "./dashboard";
import Contract from "./Contract";
import Matrix from "./matrix";
import Pools from "./Pools";
import { ethers } from 'ethers';
import getWallet, {disconnectWallet} from '../../services/wallet';
import withWrapper from '../../helpers/withWrapper';
import getContract from "../../services/contract";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { Flip, ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Buso from "./Buso";

class DashboardLayout extends Component {
  constructor(props) {
    super(props);
    if(props.router.params.id > 0) {
      this.state.userId = props.router.params.id;
    }
    else {
      this.state.userId = 1;
    }
    // this.notify("Global Reward has no longer been accumulated, All new 10% distribution has been moving to BUSO treasury, But you can still claim");
  }
  state = {
    view: 'dashboard',
    isViewMode: false,
    signer: null,
    userAddress: '',
    isSideBarOpen: false,
  };

  async componentDidMount() {
    await this.handleConnectWallet()
  }

  handleSetUserId = (id) => {
    this.setState({userId: id});
  }

  connectWallet = async () => {
    const wallet = await getWallet();
    if(!wallet.isReadOnly) {
      const browserAddresses = await wallet.provider.listAccounts();
      this.setState({ signer: wallet.signer, userAddress: browserAddresses[0] });
      console.log("Wallet Connected");
    }
  }

  handleWalletConnected = async (contract) => {
    this.setState({ signer: contract.signer });
  }

  handleConnectWallet = async () => {
    await this.connectWallet();
  }

  handleDashboardClick = () => {
    this.props.router.navigate('/dashboard/' + this.state.userId);
    toast.dismiss()
    this.sideBarToggle()
  }

  handlePoolClick = () => {
    this.props.router.navigate('/global-rewards/' + this.state.userId + '/' + 1);
    toast.dismiss()
    this.sideBarToggle()
  }

  handlePool1Click = () => {
    this.props.router.navigate('/global-rewards/' + this.state.userId + '/' + 1);
    toast.dismiss()
    this.sideBarToggle()
  }

  handlePool2Click = () => {
    this.props.router.navigate('/global-rewards/' + this.state.userId + '/' + 2);
    toast.dismiss()
    this.sideBarToggle()
  }

  handlePool3Click = () => {
    this.props.router.navigate('/global-rewards/' + this.state.userId + '/' + 3);
    toast.dismiss()
    this.sideBarToggle()
  }

  handleBusoClick = () => {
    this.props.router.navigate('/buso/' + this.state.userId);
    toast.dismiss()
    this.sideBarToggle()
  }

  handleBuso126Click = () => {
    this.props.router.navigate('/buso126/' + this.state.userId);
    toast.dismiss()
    this.sideBarToggle()
  }

  handleStakeClick = () => {
    this.props.router.navigate('/staking/' + this.state.userId);
    toast.dismiss()
    this.sideBarToggle()
  }

  handleContractClick = () => {
    this.props.router.navigate('/contracts');
    toast.dismiss()
    this.sideBarToggle()
  }

  sideBarToggle = () => {
    this.setState({isSideBarOpen: !this.state.isSideBarOpen})
  }

  handleNavigateToRegister = (userId) => {
    this.props.router.navigate('/?refId=' + userId);
  }

  handleNavigateToLogin = () => {
    this.props.router.navigate('/login');
  }

  handleSetUserId = (id) => {
    this.setState({userId: id});
  }

  handleSlotClick = (level) => {
    this.props.router.navigate('/dashboard/' + this.state.userId + '/' + level);
    this.setState({ level, view: 'matrix' });
  }

  handleDisconnect = async () => {
      disconnectWallet();
      this.setState({ signer: null });
  }
  
  notify = (message) => toast.warn(message, 
    {position: toast.POSITION.TOP_LEFT, delay: "20000", style: {zIndex: "2"}, transition: Flip, autoClose: 10000 });
 
  render() {
    return (
      <div id="__next1">
        <ToastContainer position="bottom-right" />
        <div
          className="relative flex bg-main-bg items-center justify-center min-h-screen min-w-full overflow-hidden"
          style={{ background: "rgba(0, 0, 0, 0.25)" }}
        >
          <Header
            onConnectWallet={this.handleConnectWallet}
            userAddress={this.state.userAddress}
            signer={this.state.signer}
            sideBarToggle={this.sideBarToggle}
            onDisconnect={this.handleDisconnect}
          />
          <div className="flex w-full h-full justify-center max-w-desktop-full">
            <SidePanel onDashboardClick={this.handleDashboardClick} 
              id={this.state.userId}
              onPool1Click={this.handlePool1Click}
              onPool2Click={this.handlePool2Click}
              onPool3Click={this.handlePool3Click}
              onBuso126Click={this.handleBuso126Click}
              onStakeClick={this.handleStakeClick}
              sideBarOpened={this.state.isSideBarOpen}
              onContractsClick={this.handleContractClick}
            />
            <Routes>
              <Route path="dashboard/:id" element={<Dashboard 
                navigateToRegister={this.handleNavigateToRegister}
                onSetUserId={(id) => this.handleSetUserId(id)}
                onSlotClick={this.handleSlotClick}
                isViewMode={this.state.isViewMode}
                userId={this.state.userId}
                onWalletConnected={this.handleWalletConnected}
              />} />
              <Route path="dashboard/:id/:level" element={<Matrix 
                onSetUserId={(id) => this.handleSetUserId(id)}
                router={this.props.router}
                level={this.state.level}
                userId={this.state.userId}
                idsOnLevel={this.state.idsOnLevel}
              />} />

              {/* <Route path="buso126/:id/" element={<Buso126
                router={this.props.router}
                userId={this.state.userId}
                signer={this.state.signer}
              />} /> */}

              {/* <Route path="staking/:id/" element={<BusoFarm
                onSetUserId={(id) => this.handleSetUserId(id)}
                isViewMode={this.state.isViewMode}
                userId={this.state.userId}
                onWalletConnected={this.handleWalletConnected}
              />} /> */}

            <Route path="global-rewards/:id/:level" element={<Pools 
                onSetUserId={(id) => this.handleSetUserId(id)}
                isViewMode={this.state.isViewMode}
                userId={this.state.userId}
                onWalletConnected={this.handleWalletConnected}
              />} />

            <Route path="contracts" element={<Contract userId={this.state.userId} />} />
            
            </Routes>
          </div>
        </div>
      </div>
    );
  }
}

export default withWrapper(DashboardLayout);
